var _classCallCheck = require("/workspace/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/workspace/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/workspace/node_modules/react-scripts/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/workspace/node_modules/react-scripts/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/workspace/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/workspace/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _objectSpread = require("/workspace/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread");
/*! For license information please see ReactCrop.min.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactCrop = t(require("react")) : e.ReactCrop = t(e.React);
}(this, function (e) {
  return function () {
    "use strict";

    var t = {
        418: function _(e) {
          var t = Object.getOwnPropertySymbols,
            r = Object.prototype.hasOwnProperty,
            i = Object.prototype.propertyIsEnumerable;
          function o(e) {
            if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(e);
          }
          e.exports = function () {
            try {
              if (!Object.assign) return !1;
              var e = new String("abc");
              if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
              for (var t = {}, r = 0; r < 10; r++) t["_" + String.fromCharCode(r)] = r;
              if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
                return t[e];
              }).join("")) return !1;
              var i = {};
              return "abcdefghijklmnopqrst".split("").forEach(function (e) {
                i[e] = e;
              }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
            } catch (e) {
              return !1;
            }
          }() ? Object.assign : function (e, n) {
            for (var s, a, h = o(e), d = 1; d < arguments.length; d++) {
              for (var c in s = Object(arguments[d])) r.call(s, c) && (h[c] = s[c]);
              if (t) {
                a = t(s);
                for (var p = 0; p < a.length; p++) i.call(s, a[p]) && (h[a[p]] = s[a[p]]);
              }
            }
            return h;
          };
        },
        251: function _(e, t, r) {
          r(418);
          var i = r(899),
            o = 60103;
          if (t.Fragment = 60107, "function" == typeof Symbol && Symbol.for) {
            var n = Symbol.for;
            o = n("react.element"), t.Fragment = n("react.fragment");
          }
          var s = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
            a = Object.prototype.hasOwnProperty,
            h = {
              key: !0,
              ref: !0,
              __self: !0,
              __source: !0
            };
          function d(e, t, r) {
            var i,
              n = {},
              d = null,
              c = null;
            for (i in void 0 !== r && (d = "" + r), void 0 !== t.key && (d = "" + t.key), void 0 !== t.ref && (c = t.ref), t) a.call(t, i) && !h.hasOwnProperty(i) && (n[i] = t[i]);
            if (e && e.defaultProps) for (i in t = e.defaultProps) void 0 === n[i] && (n[i] = t[i]);
            return {
              $$typeof: o,
              type: e,
              key: d,
              ref: c,
              props: n,
              _owner: s.current
            };
          }
          t.jsx = d, t.jsxs = d;
        },
        893: function _(e, t, r) {
          e.exports = r(251);
        },
        899: function _(t) {
          t.exports = e;
        }
      },
      r = {};
    function i(e) {
      var o = r[e];
      if (void 0 !== o) return o.exports;
      var n = r[e] = {
        exports: {}
      };
      return t[e](n, n.exports, i), n.exports;
    }
    i.d = function (e, t) {
      for (var r in t) i.o(t, r) && !i.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }, i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, i.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var o = {};
    return function () {
      i.r(o), i.d(o, {
        Component: function Component() {
          return f;
        },
        areCropsEqual: function areCropsEqual() {
          return h;
        },
        clamp: function clamp() {
          return s;
        },
        convertToPercentCrop: function convertToPercentCrop() {
          return c;
        },
        convertToPixelCrop: function convertToPixelCrop() {
          return p;
        },
        default: function _default() {
          return f;
        },
        defaultCrop: function defaultCrop() {
          return n;
        },
        getMaxCrop: function getMaxCrop() {
          return g;
        },
        getMinCrop: function getMinCrop() {
          return w;
        },
        isCropValid: function isCropValid() {
          return a;
        },
        makeAspectCrop: function makeAspectCrop() {
          return d;
        },
        resolveCrop: function resolveCrop() {
          return l;
        }
      });
      var e = i(893),
        t = i(899);
      function r(e) {
        var t,
          i,
          o = "";
        if ("string" == typeof e || "number" == typeof e) o += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (i = r(e[t])) && (o && (o += " "), o += i);else for (t in e) e[t] && (o && (o += " "), o += t);
        return o;
      }
      var n = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        unit: "px"
      };
      function s(e, t, r) {
        return Math.min(Math.max(e, t), r);
      }
      function a(e) {
        return e && e.width && !isNaN(e.width) && e.height && !isNaN(e.height);
      }
      function h(e, t) {
        return e.width === t.width && e.height === t.height && e.x === t.x && e.y === t.y && e.aspect === t.aspect && e.unit === t.unit;
      }
      function d(e, t, r) {
        if (!e.aspect || isNaN(e.aspect)) return console.error("`crop.aspect` should be a number.", e), _objectSpread({}, n, e);
        var i = {
          unit: "px",
          x: e.x || 0,
          y: e.y || 0,
          width: e.width || 0,
          height: e.height || 0,
          aspect: e.aspect
        };
        return e.width && (i.height = i.width / e.aspect), e.height && (i.width = i.height * e.aspect), i.y + i.height > r && (i.height = r - i.y, i.width = i.height * e.aspect), i.x + i.width > t && (i.width = t - i.x, i.height = i.width / e.aspect), i;
      }
      function c(e, t, r) {
        return "%" === e.unit ? _objectSpread({}, n, e) : {
          unit: "%",
          aspect: e.aspect,
          x: e.x ? e.x / t * 100 : 0,
          y: e.y ? e.y / r * 100 : 0,
          width: e.width ? e.width / t * 100 : 0,
          height: e.height ? e.height / r * 100 : 0
        };
      }
      function p(e, t, r) {
        return e.unit ? "px" === e.unit ? _objectSpread({}, n, e) : {
          unit: "px",
          aspect: e.aspect,
          x: e.x ? e.x * t / 100 : 0,
          y: e.y ? e.y * r / 100 : 0,
          width: e.width ? e.width * t / 100 : 0,
          height: e.height ? e.height * r / 100 : 0
        } : _objectSpread({}, n, e, {
          unit: "px"
        });
      }
      function l(e, t, r) {
        return !e.aspect || e.width && e.height ? e : d(e, t, r);
      }
      function w(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var o = _objectSpread({}, e);
        return o.aspect ? r < i ? (o.width = r, o.height = o.width / o.aspect) : (o.width = i * o.aspect, o.height = i) : (o.width = r, o.height = i), "n" === t || "ne" === t ? o.y += e.height - o.height : "sw" === t ? o.x += e.width - o.width : "nw" === t ? (o.x += e.width - o.width, o.y += e.height - o.height) : "w" === t && (o.x += e.width - o.width), o;
      }
      function g(e, t, r, i) {
        var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : r;
        var n = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : i;
        var s = _objectSpread({}, e),
          a = function a() {
            return Math.min(o, s.x + s.width);
          },
          h = function h() {
            return Math.min(n, s.y + s.height);
          },
          d = function d() {
            return Math.min(o, r - s.x);
          },
          c = function c() {
            return Math.min(n, i - s.y);
          };
        if (s.aspect) {
          var _r = 0,
            _i = 0;
          "ne" === t ? (_r = d(), _i = h()) : "se" === t ? (_r = d(), _i = c()) : "sw" === t ? (_r = a(), _i = c()) : "nw" === t && (_r = a(), _i = h());
          var _o = _r / s.width,
            _n = _i / s.height,
            _p = Math.min(_o, _n),
            _l = s.width * _p,
            _w = _l / s.aspect;
          "ne" === t ? s.y = s.y + (e.height - _w) : "sw" === t ? s.x = s.x + (e.width - _l) : "nw" === t && (s.x = s.x + (e.width - _l), s.y = s.y + (e.height - _w)), s.width = _l, s.height = _w;
        } else if ("n" === t) {
          var _e = h();
          s.y -= _e - s.height, s.height = _e;
        } else if ("ne" === t) {
          var _e2 = h();
          s.y -= _e2 - s.height, s.height = _e2, s.width = d();
        } else if ("e" === t) s.width = d();else if ("se" === t) s.width = d(), s.height = c();else if ("s" === t) s.height = c();else if ("sw" === t) {
          var _e3 = a();
          s.x -= _e3 - s.width, s.width = _e3, s.height = c();
        } else if ("w" === t) {
          var _e4 = a();
          s.x -= _e4 - s.width, s.width = _e4;
        } else if ("nw" === t) {
          var _e5 = h();
          s.y -= _e5 - s.height, s.height = _e5;
          var _t = a();
          s.x -= _t - s.width, s.width = _t;
        }
        return s;
      }
      var u = {
        capture: !0,
        passive: !1
      };
      var f = /*#__PURE__*/function (_t$PureComponent) {
        _inherits(f, _t$PureComponent);
        function f() {
          var _this;
          _classCallCheck(this, f);
          _this = _possibleConstructorReturn(this, _getPrototypeOf(f).apply(this, arguments)), _this.keysDown = new Set(), _this.docMoveBound = !1, _this.mouseDownOnCrop = !1, _this.dragStarted = !1, _this.evData = {
            clientStartX: 0,
            clientStartY: 0,
            cropStartWidth: 0,
            cropStartHeight: 0,
            cropStartX: 0,
            cropStartY: 0,
            xDiff: 0,
            yDiff: 0,
            xInversed: !1,
            yInversed: !1,
            xCrossOver: !1,
            yCrossOver: !1,
            lastYCrossover: !1,
            startXCrossOver: !1,
            startYCrossOver: !1,
            isResize: !0,
            ord: "nw"
          }, _this.componentRef = (0, t.createRef)(), _this.mediaWrapperRef = (0, t.createRef)(), _this.imageRef = (0, t.createRef)(), _this.cropSelectRef = (0, t.createRef)(), _this.state = {
            cropIsActive: !1,
            newCropIsBeingDrawn: !1
          }, _this.onCropPointerDown = function (e) {
            var _this$props = _this.props,
              t = _this$props.crop,
              r = _this$props.disabled,
              _this$mediaDimensions = _this.mediaDimensions,
              i = _this$mediaDimensions.width,
              o = _this$mediaDimensions.height,
              n = p(t, i, o);
            if (r) return;
            e.cancelable && e.preventDefault(), _this.bindDocMove(), _this.componentRef.current.focus({
              preventScroll: !0
            });
            var s = e.target.dataset.ord,
              a = "nw" === s || "w" === s || "sw" === s,
              h = "nw" === s || "n" === s || "ne" === s;
            _this.evData = {
              clientStartX: e.clientX,
              clientStartY: e.clientY,
              cropStartWidth: n.width,
              cropStartHeight: n.height,
              cropStartX: a ? n.x + n.width : n.x,
              cropStartY: h ? n.y + n.height : n.y,
              xDiff: 0,
              yDiff: 0,
              xInversed: a,
              yInversed: h,
              xCrossOver: a,
              yCrossOver: h,
              lastYCrossover: h,
              startXCrossOver: a,
              startYCrossOver: h,
              isResize: Boolean(s),
              ord: s || "ne"
            }, _this.mouseDownOnCrop = !0, _this.setState({
              cropIsActive: !0
            });
          }, _this.onComponentPointerDown = function (e) {
            var _this$props2 = _this.props,
              t = _this$props2.crop,
              r = _this$props2.disabled,
              i = _this$props2.locked,
              o = _this$props2.keepSelection,
              n = _this$props2.onChange,
              _this$props2$zoom = _this$props2.zoom,
              s = _this$props2$zoom === void 0 ? 1 : _this$props2$zoom,
              _this$props2$spin = _this$props2.spin,
              h = _this$props2$spin === void 0 ? 0 : _this$props2$spin,
              d = _this.mediaWrapperRef.current.firstChild;
            if (e.target !== d || !d.contains(e.target)) return;
            if (r || i || o && a(t)) return;
            e.cancelable && e.preventDefault(), _this.bindDocMove(), _this.componentRef.current.focus({
              preventScroll: !0
            });
            var l = _this.mediaWrapperRef.current.getBoundingClientRect();
            var w = 0,
              g = 0,
              u = (e.clientX - l.left) / s,
              f = (e.clientY - l.top) / s,
              y = h,
              m = Math.abs(y * Math.PI / 180);
            y > -45 && y <= 45 || Math.abs(y) > 135 && Math.abs(y) <= 180 ? (w = u * Math.cos(m), g = f * Math.cos(m)) : y > 45 && y <= 135 ? (w = f * Math.sin(m), g = u * Math.sin(m) * -1) : y > -135 && y <= -45 && (w = f * Math.sin(m) * -1, g = u * Math.sin(m));
            var v = {
                unit: "px",
                aspect: t ? t.aspect : void 0,
                x: w,
                y: g,
                width: 0,
                height: 0
              },
              _this$mediaDimensions2 = _this.mediaDimensions,
              x = _this$mediaDimensions2.width,
              C = _this$mediaDimensions2.height;
            _this.evData = {
              clientStartX: e.clientX,
              clientStartY: e.clientY,
              cropStartWidth: v.width,
              cropStartHeight: v.height,
              cropStartX: v.x,
              cropStartY: v.y,
              xDiff: 0,
              yDiff: 0,
              xInversed: !1,
              yInversed: !1,
              xCrossOver: !1,
              yCrossOver: !1,
              lastYCrossover: !1,
              startXCrossOver: !1,
              startYCrossOver: !1,
              isResize: !0,
              ord: "nw"
            }, _this.mouseDownOnCrop = !0, n(p(v, x, C), c(v, x, C)), _this.setState({
              cropIsActive: !0,
              newCropIsBeingDrawn: !0
            });
          }, _this.onDocPointerMove = function (e) {
            var _this$props3 = _this.props,
              t = _this$props3.crop,
              r = _this$props3.disabled,
              i = _this$props3.onChange,
              o = _this$props3.onDragStart,
              _this$props3$zoom = _this$props3.zoom,
              n = _this$props3$zoom === void 0 ? 1 : _this$props3$zoom,
              _this$props3$spin = _this$props3.spin,
              s = _this$props3$spin === void 0 ? 0 : _this$props3$spin;
            if (r) return;
            if (!_this.mouseDownOnCrop) return;
            e.cancelable && e.preventDefault(), _this.dragStarted || (_this.dragStarted = !0, o && o(e));
            var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
              a = _assertThisInitialize.evData;
            var h,
              d = (e.clientX - a.clientStartX) / n,
              l = (e.clientY - a.clientStartY) / n,
              w = s,
              g = Math.abs(w * Math.PI / 180);
            if (w > -45 && w <= 45 || Math.abs(w) > 135 && Math.abs(w) <= 180 ? (a.xDiff = d * Math.cos(g), a.yDiff = l * Math.cos(g)) : w > 45 && w <= 135 ? (a.xDiff = l * Math.sin(g), a.yDiff = d * Math.sin(g) * -1) : w > -135 && w <= -45 && (a.xDiff = l * Math.sin(g) * -1, a.yDiff = d * Math.sin(g)), h = a.isResize ? _this.resizeCrop() : _this.dragCrop(), h !== t) {
              var _this$mediaDimensions3 = _this.mediaDimensions,
                _e6 = _this$mediaDimensions3.width,
                _t2 = _this$mediaDimensions3.height;
              i(p(h, _e6, _t2), c(h, _e6, _t2));
            }
          }, _this.onComponentKeyDown = function (e) {
            var _this$props4 = _this.props,
              t = _this$props4.crop,
              r = _this$props4.disabled,
              i = _this$props4.onChange,
              o = _this$props4.onComplete;
            if (r) return;
            _this.keysDown.add(e.key);
            var n = !1;
            if (!a(t)) return;
            var h = _this.makeNewCrop(),
              d = (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) ? f.nudgeStepLarge : e.shiftKey ? f.nudgeStepMedium : f.nudgeStep;
            if (_this.keysDown.has("ArrowLeft") && (h.x -= d, n = !0), _this.keysDown.has("ArrowRight") && (h.x += d, n = !0), _this.keysDown.has("ArrowUp") && (h.y -= d, n = !0), _this.keysDown.has("ArrowDown") && (h.y += d, n = !0), n) {
              e.cancelable && e.preventDefault();
              var _this$mediaDimensions4 = _this.mediaDimensions,
                _t3 = _this$mediaDimensions4.width,
                _r2 = _this$mediaDimensions4.height;
              h.x = s(h.x, 0, _t3 - h.width), h.y = s(h.y, 0, _r2 - h.height);
              var _n2 = p(h, _t3, _r2),
                _a = c(h, _t3, _r2);
              i(_n2, _a), o && o(_n2, _a);
            }
          }, _this.onHandlerKeyDown = function (e, t) {
            var _this$props5 = _this.props,
              r = _this$props5.crop,
              i = _this$props5.disabled,
              o = _this$props5.minWidth,
              n = _this$props5.minHeight,
              s = _this$props5.maxWidth,
              d = _this$props5.maxHeight,
              l = _this$props5.onChange,
              u = _this$props5.onComplete,
              _this$mediaDimensions5 = _this.mediaDimensions,
              y = _this$mediaDimensions5.width,
              m = _this$mediaDimensions5.height;
            if (i) return;
            if (!a(r)) return;
            if ("ArrowUp" !== e.key && "ArrowDown" !== e.key && "ArrowLeft" !== e.key && "ArrowRight" !== e.key) return;
            e.stopPropagation(), e.preventDefault();
            var v = p(r, y, m),
              x = g(v, t, y, m, s, d),
              C = w(v, t, o, n),
              D = (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) ? f.nudgeStepLarge : e.shiftKey ? f.nudgeStepMedium : f.nudgeStep;
            var b = !1,
              S = !1;
            if ("ArrowLeft" === e.key ? "nw" === t || "w" === t || "sw" === t ? (b = !0, v.x = Math.max(x.x, v.x - D), v.width = Math.min(x.width, v.width + D)) : "ne" !== t && "e" !== t && "se" !== t || (b = !0, v.width = Math.max(C.width, v.width - D)) : "ArrowRight" === e.key && ("nw" === t || "w" === t || "sw" === t ? (b = !0, v.x = Math.min(C.x, v.x + D), v.width = Math.max(C.width, v.width - D)) : "ne" !== t && "e" !== t && "se" !== t || (b = !0, v.width = Math.min(x.width, v.width + D))), "ArrowUp" === e.key ? "nw" === t || "n" === t || "ne" === t ? (S = !0, v.y = Math.max(x.y, Math.max(0, v.y - D)), v.height = Math.min(x.height, v.height + D)) : "sw" !== t && "s" !== t && "se" !== t || (S = !0, v.height = Math.max(C.height, v.height - D)) : "ArrowDown" === e.key && ("nw" === t || "n" === t || "ne" === t ? (S = !0, v.y = Math.min(C.y, v.y + D), v.height = Math.max(C.height, v.height - D)) : "sw" !== t && "s" !== t && "se" !== t || (S = !0, v.height = Math.min(x.height, v.height + D))), v.aspect) if (b) v.height = v.width / v.aspect;else if (S) {
              var _e7 = v.width;
              v.width = v.height * v.aspect, "nw" !== t && "sw" !== t || (v.x -= v.width - _e7);
            }
            if (!h(r, v)) {
              var _e8 = c(v, y, m);
              l(v, _e8), u && u(v, _e8);
            }
          }, _this.onComponentKeyUp = function (e) {
            _this.keysDown.delete(e.key);
          }, _this.onDocPointerDone = function (e) {
            var _this$props6 = _this.props,
              t = _this$props6.crop,
              r = _this$props6.disabled,
              i = _this$props6.onComplete,
              o = _this$props6.onDragEnd;
            if (_this.unbindDocMove(), !r && _this.mouseDownOnCrop) {
              _this.mouseDownOnCrop = !1, _this.dragStarted = !1;
              var _this$mediaDimensions6 = _this.mediaDimensions,
                _r3 = _this$mediaDimensions6.width,
                _n3 = _this$mediaDimensions6.height;
              o && o(e), i && i(p(t, _r3, _n3), c(t, _r3, _n3)), _this.setState({
                cropIsActive: !1,
                newCropIsBeingDrawn: !1
              });
            }
          }, _this.onMediaLoaded = function () {
            var _this$props7 = _this.props,
              e = _this$props7.onComplete,
              t = _this$props7.onChange,
              _this$createNewCrop = _this.createNewCrop(),
              r = _this$createNewCrop.pixelCrop,
              i = _this$createNewCrop.percentCrop;
            t(r, i), e && e(r, i);
          }, _this.onImageLoad = function (e) {
            var _this$props8 = _this.props,
              t = _this$props8.onComplete,
              r = _this$props8.onChange,
              i = _this$props8.onImageLoaded;
            if (!1 !== (!i || i(e.currentTarget))) {
              var _this$createNewCrop2 = _this.createNewCrop(),
                _e9 = _this$createNewCrop2.pixelCrop,
                _i2 = _this$createNewCrop2.percentCrop;
              r(_e9, _i2), t && t(_e9, _i2);
            }
          };
          return _this;
        }
        _createClass(f, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.componentRef.current && this.componentRef.current.addEventListener("medialoaded", this.onMediaLoaded);
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.componentRef.current && this.componentRef.current.removeEventListener("medialoaded", this.onMediaLoaded);
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(e) {
            var _this$props9 = this.props,
              t = _this$props9.crop,
              r = _this$props9.onChange,
              i = _this$props9.onComplete;
            if (this.imageRef.current && t && e.crop !== t && t.aspect && (t.width && !t.height || !t.width && t.height)) {
              var _this$imageRef$curren = this.imageRef.current,
                _e10 = _this$imageRef$curren.width,
                _t4 = _this$imageRef$curren.height,
                _o2 = d(this.makeNewCrop(), _e10, _t4),
                _n4 = p(_o2, _e10, _t4),
                _s = c(_o2, _e10, _t4);
              r(_n4, _s), i && i(_n4, _s);
            }
          }
        }, {
          key: "bindDocMove",
          value: function bindDocMove() {
            this.docMoveBound || (document.addEventListener("pointermove", this.onDocPointerMove, u), document.addEventListener("pointerup", this.onDocPointerDone, u), document.addEventListener("pointercancel", this.onDocPointerDone, u), this.docMoveBound = !0);
          }
        }, {
          key: "unbindDocMove",
          value: function unbindDocMove() {
            this.docMoveBound && (document.removeEventListener("pointermove", this.onDocPointerMove, u), document.removeEventListener("pointerup", this.onDocPointerDone, u), document.removeEventListener("pointercancel", this.onDocPointerDone, u), this.docMoveBound = !1);
          }
        }, {
          key: "createNewCrop",
          value: function createNewCrop() {
            var _this$mediaDimensions7 = this.mediaDimensions,
              e = _this$mediaDimensions7.width,
              t = _this$mediaDimensions7.height,
              r = l(this.makeNewCrop(), e, t);
            return {
              pixelCrop: p(r, e, t),
              percentCrop: c(r, e, t)
            };
          }
        }, {
          key: "getCropStyle",
          value: function getCropStyle() {
            var e = this.makeNewCrop(this.props.crop ? this.props.crop.unit : "px");
            return {
              top: "".concat(e.y).concat(e.unit),
              left: "".concat(e.x).concat(e.unit),
              width: "".concat(e.width).concat(e.unit),
              height: "".concat(e.height).concat(e.unit)
            };
          }
        }, {
          key: "getNewSize",
          value: function getNewSize() {
            var _this$props10 = this.props,
              e = _this$props10.crop,
              _this$props10$minWidt = _this$props10.minWidth,
              t = _this$props10$minWidt === void 0 ? 0 : _this$props10$minWidt,
              r = _this$props10.maxWidth,
              _this$props10$minHeig = _this$props10.minHeight,
              i = _this$props10$minHeig === void 0 ? 0 : _this$props10$minHeig,
              o = _this$props10.maxHeight,
              n = this.evData,
              _this$mediaDimensions8 = this.mediaDimensions,
              a = _this$mediaDimensions8.width,
              h = _this$mediaDimensions8.height;
            var d,
              c = n.cropStartWidth + n.xDiff;
            return n.xCrossOver && (c = Math.abs(c)), c = s(c, t, r || a), d = e.aspect ? c / e.aspect : n.cropStartHeight + n.yDiff, n.yCrossOver && (d = Math.min(Math.abs(d), n.cropStartY)), d = s(d, i, o || h), e.aspect && (c = s(d * e.aspect, 0, a)), {
              width: c,
              height: d
            };
          }
        }, {
          key: "dragCrop",
          value: function dragCrop() {
            var e = this.makeNewCrop(),
              t = this.evData,
              _this$mediaDimensions9 = this.mediaDimensions,
              r = _this$mediaDimensions9.width,
              i = _this$mediaDimensions9.height;
            return e.x = s(t.cropStartX + t.xDiff, 0, r - e.width), e.y = s(t.cropStartY + t.yDiff, 0, i - e.height), e;
          }
        }, {
          key: "resizeCrop",
          value: function resizeCrop() {
            var e = this.evData,
              _this$props11 = this.props,
              t = _this$props11.crop,
              _this$props11$minWidt = _this$props11.minWidth,
              r = _this$props11$minWidt === void 0 ? 0 : _this$props11$minWidt,
              _this$props11$minHeig = _this$props11.minHeight,
              i = _this$props11$minHeig === void 0 ? 0 : _this$props11$minHeig,
              o = this.makeNewCrop(),
              n = e.ord;
            e.xInversed && (e.xDiff -= 2 * e.cropStartWidth), e.yInversed && (e.yDiff -= 2 * e.cropStartHeight);
            var s = this.getNewSize();
            var a = e.cropStartX,
              h = e.cropStartY;
            e.xCrossOver && (a = o.x + (o.width - s.width)), e.yCrossOver && (h = !1 === e.lastYCrossover ? o.y - s.height : o.y + (o.height - s.height));
            var _this$mediaDimensions10 = this.mediaDimensions,
              d = _this$mediaDimensions10.width,
              c = _this$mediaDimensions10.height,
              l = function (e, t, r, i) {
                var o = p(t, r, i),
                  n = p(e, r, i);
                return o.aspect ? (o.x < 0 ? (o.width = o.x + o.width, o.x = 0, o.height = o.width / o.aspect) : o.x + o.width > r && (o.width = r - o.x, o.height = o.width / o.aspect), n.y > o.y && (o.x + o.width >= r || o.x <= 0) && (o.height += n.height - o.height, o.y = n.y), o.y < 0 ? (o.height = o.y + o.height, o.y = 0, o.width = o.height * o.aspect) : o.y + o.height > i && (o.height = i - o.y, o.width = o.height * o.aspect), o.x < n.x && o.y + o.height >= i && (o.width += n.width - o.width, o.x = n.x), o) : (o.x < 0 ? (o.width += o.x, o.x = 0) : o.x + o.width > r && (o.width = r - o.x), o.y + o.height > i && (o.height = i - o.y), o);
              }(this.props.crop, {
                unit: o.unit,
                x: a,
                y: h,
                width: s.width,
                height: s.height,
                aspect: o.aspect
              }, d, c);
            return o.aspect || f.xyOrds.indexOf(n) > -1 ? (o.x = l.x, o.y = l.y, o.width = l.width, o.height = l.height) : f.xOrds.indexOf(n) > -1 ? (o.x = l.x, o.width = l.width) : f.yOrds.indexOf(n) > -1 && (o.y = l.y, o.height = l.height), e.lastYCrossover = e.yCrossOver, this.crossOverCheck(), o.width < r || o.height < i ? t : o;
          }
        }, {
          key: "getRotatedCursor",
          value: function getRotatedCursor(e, t) {
            if (t > -135 && t <= -45 || t > 45 && t <= 135) switch (e) {
              case "nw":
                return {
                  cursor: "ne-resize"
                };
              case "n":
                return {
                  cursor: "w-resize"
                };
              case "ne":
                return {
                  cursor: "nw-resize"
                };
              case "e":
                return {
                  cursor: "s-resize"
                };
              case "se":
                return {
                  cursor: "sw-resize"
                };
              case "s":
                return {
                  cursor: "e-resize"
                };
              case "sw":
                return {
                  cursor: "se-resize"
                };
              case "w":
                return {
                  cursor: "n-resize"
                };
            }
          }
        }, {
          key: "createCropSelection",
          value: function createCropSelection() {
            var _this2 = this;
            var _this$props12 = this.props,
              t = _this$props12.ariaLabels,
              r = _this$props12.disabled,
              i = _this$props12.locked,
              o = _this$props12.renderSelectionAddon,
              n = _this$props12.ruleOfThirds,
              s = _this$props12.crop,
              _this$props12$spin = _this$props12.spin,
              h = _this$props12$spin === void 0 ? 0 : _this$props12$spin,
              d = this.getCropStyle();
            return (0, e.jsxs)("div", {
              style: d,
              className: "ReactCrop__crop-selection",
              onPointerDown: this.onCropPointerDown,
              "aria-label": this.props.ariaLabels && this.props.ariaLabels.cropArea ? this.props.ariaLabels.cropArea : "Use the arrow keys to move the crop selection area",
              tabIndex: 0,
              onKeyDown: this.onComponentKeyDown,
              onKeyUp: this.onComponentKeyUp,
              children: [!r && !i && (0, e.jsxs)("div", {
                className: "ReactCrop__drag-elements",
                children: [(0, e.jsx)("div", {
                  className: "ReactCrop__drag-bar ord-n",
                  "data-ord": "n"
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__drag-bar ord-e",
                  "data-ord": "e"
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__drag-bar ord-s",
                  "data-ord": "s"
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__drag-bar ord-w",
                  "data-ord": "w"
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-nw",
                  "data-ord": "nw",
                  style: this.getRotatedCursor("nw", h),
                  tabIndex: 0,
                  "aria-label": (null == t ? void 0 : t.nwDragHandle) || "Use the arrow keys to move the north west drag handle to change the crop selection area",
                  onKeyDown: function onKeyDown(e) {
                    _this2.onHandlerKeyDown(e, "nw");
                  }
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-n",
                  "data-ord": "n",
                  style: this.getRotatedCursor("n", h),
                  tabIndex: 0,
                  "aria-label": (null == t ? void 0 : t.nDragHandle) || "Use the up and down arrow keys to move the north drag handle to change the crop selection area",
                  onKeyDown: function onKeyDown(e) {
                    _this2.onHandlerKeyDown(e, "n");
                  }
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-ne",
                  "data-ord": "ne",
                  style: this.getRotatedCursor("ne", h),
                  tabIndex: 0,
                  "aria-label": (null == t ? void 0 : t.neDragHandle) || "Use the arrow keys to move the north east drag handle to change the crop selection area",
                  onKeyDown: function onKeyDown(e) {
                    _this2.onHandlerKeyDown(e, "ne");
                  }
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-e",
                  "data-ord": "e",
                  style: this.getRotatedCursor("e", h),
                  tabIndex: 0,
                  "aria-label": (null == t ? void 0 : t.eDragHandle) || "Use the up and down arrow keys to move the east drag handle to change the crop selection area",
                  onKeyDown: function onKeyDown(e) {
                    _this2.onHandlerKeyDown(e, "e");
                  }
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-se",
                  "data-ord": "se",
                  style: this.getRotatedCursor("se", h),
                  tabIndex: 0,
                  "aria-label": (null == t ? void 0 : t.seDragHandle) || "Use the arrow keys to move the south east drag handle to change the crop selection area",
                  onKeyDown: function onKeyDown(e) {
                    _this2.onHandlerKeyDown(e, "se");
                  }
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-s",
                  "data-ord": "s",
                  style: this.getRotatedCursor("s", h),
                  tabIndex: 0,
                  "aria-label": (null == t ? void 0 : t.sDragHandle) || "Use the up and down arrow keys to move the south drag handle to change the crop selection area",
                  onKeyDown: function onKeyDown(e) {
                    _this2.onHandlerKeyDown(e, "s");
                  }
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-sw",
                  "data-ord": "sw",
                  style: this.getRotatedCursor("sw", h),
                  tabIndex: 0,
                  "aria-label": (null == t ? void 0 : t.swDragHandle) || "Use the arrow keys to move the south west drag handle to change the crop selection area",
                  onKeyDown: function onKeyDown(e) {
                    _this2.onHandlerKeyDown(e, "sw");
                  }
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-w",
                  "data-ord": "w",
                  style: this.getRotatedCursor("w", h),
                  tabIndex: 0,
                  "aria-label": (null == t ? void 0 : t.wDragHandle) || "Use the up and down arrow keys to move the west drag handle to change the crop selection area",
                  onKeyDown: function onKeyDown(e) {
                    _this2.onHandlerKeyDown(e, "w");
                  }
                }, void 0)]
              }, void 0), o && a(s) && (0, e.jsx)("div", {
                className: "ReactCrop__selection-addon",
                onMouseDown: function onMouseDown(e) {
                  return e.stopPropagation();
                },
                children: o(this.state)
              }, void 0), n && (0, e.jsxs)(e.Fragment, {
                children: [(0, e.jsx)("div", {
                  className: "ReactCrop__rule-of-thirds-hz"
                }, void 0), (0, e.jsx)("div", {
                  className: "ReactCrop__rule-of-thirds-vt"
                }, void 0)]
              }, void 0)]
            }, void 0);
          }
        }, {
          key: "makeNewCrop",
          value: function makeNewCrop() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "px";
            var t = _objectSpread({}, n, this.props.crop || {}),
              _this$mediaDimensions11 = this.mediaDimensions,
              r = _this$mediaDimensions11.width,
              i = _this$mediaDimensions11.height;
            return "px" === e ? p(t, r, i) : c(t, r, i);
          }
        }, {
          key: "crossOverCheck",
          value: function crossOverCheck() {
            var e = this.evData,
              _this$props13 = this.props,
              t = _this$props13.minWidth,
              r = _this$props13.minHeight;
            !t && (!e.xCrossOver && -Math.abs(e.cropStartWidth) - e.xDiff >= 0 || e.xCrossOver && -Math.abs(e.cropStartWidth) - e.xDiff <= 0) && (e.xCrossOver = !e.xCrossOver), !r && (!e.yCrossOver && -Math.abs(e.cropStartHeight) - e.yDiff >= 0 || e.yCrossOver && -Math.abs(e.cropStartHeight) - e.yDiff <= 0) && (e.yCrossOver = !e.yCrossOver);
          }
        }, {
          key: "render",
          value: function render() {
            var _this$props14 = this.props,
              t = _this$props14.children,
              i = _this$props14.circularCrop,
              o = _this$props14.className,
              n = _this$props14.crossorigin,
              s = _this$props14.crop,
              h = _this$props14.disabled,
              d = _this$props14.imageStyle,
              c = _this$props14.locked,
              p = _this$props14.imageAlt,
              l = _this$props14.onImageError,
              w = _this$props14.renderComponent,
              _this$props14$scale = _this$props14.scale,
              g = _this$props14$scale === void 0 ? 1 : _this$props14$scale,
              u = _this$props14.src,
              f = _this$props14.style,
              _this$props14$rotate = _this$props14.rotate,
              y = _this$props14$rotate === void 0 ? 0 : _this$props14$rotate,
              m = _this$props14.ruleOfThirds,
              _this$state = this.state,
              v = _this$state.cropIsActive,
              x = _this$state.newCropIsBeingDrawn,
              C = a(s) && this.componentRef ? this.createCropSelection() : null,
              D = function () {
                for (var e, t, i = 0, o = ""; i < arguments.length;) (e = arguments[i++]) && (t = r(e)) && (o && (o += " "), o += t);
                return o;
              }("ReactCrop", o, {
                "ReactCrop--active": v,
                "ReactCrop--disabled": h,
                "ReactCrop--locked": c,
                "ReactCrop--new-crop": x,
                "ReactCrop--fixed-aspect": s && s.aspect,
                "ReactCrop--circular-crop": s && i,
                "ReactCrop--rule-of-thirds": s && m,
                "ReactCrop--invisible-crop": !this.dragStarted && s && !s.width && !s.height
              });
            return (0, e.jsxs)("div", {
              ref: this.componentRef,
              className: D,
              style: f,
              onPointerDown: this.onComponentPointerDown,
              children: [(0, e.jsx)("div", {
                ref: this.mediaWrapperRef,
                style: {
                  transform: "scale(".concat(g, ") rotate(").concat(y, "deg)")
                },
                children: w || (0, e.jsx)("img", {
                  ref: this.imageRef,
                  crossOrigin: n,
                  className: "ReactCrop__image",
                  style: d,
                  src: u,
                  onLoad: this.onImageLoad,
                  onError: l,
                  alt: p
                }, void 0)
              }, void 0), t, C]
            }, void 0);
          }
        }, {
          key: "mediaDimensions",
          get: function get() {
            var e = this.mediaWrapperRef.current;
            if (e) {
              var _e$getBoundingClientR = e.getBoundingClientRect(),
                _t5 = _e$getBoundingClientR.width,
                _r4 = _e$getBoundingClientR.height;
              return {
                width: _t5,
                height: _r4
              };
            }
            return {
              width: 0,
              height: 0
            };
          }
        }]);
        return f;
      }(t.PureComponent);
      f.xOrds = ["e", "w"], f.yOrds = ["n", "s"], f.xyOrds = ["nw", "ne", "se", "sw"], f.nudgeStep = 1, f.nudgeStepMedium = 10, f.nudgeStepLarge = 100;
    }(), o;
  }();
});